module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/wifi.08fb7283.svg";